import React from 'react'
import cn from 'classnames'

import roomResponsiveStyles from '../styles.module.css'
import roomImageStyles from '../RoomImage/styles.module.css'
import offerResponsiveStyles from '../OfferResponsive/styles.module.css'
import offerResponsivePriceAndButtonStyles from '../OfferResponsive/OfferResponsivePriceAndButton/styles.module.css'
import styles from './styles.module.css'
import PlaceholderShadow from 'src/comps/Molecules/Placeholder/PlaceholderShadow'

const RoomCardPlaceholder = () => {
  return (
    <div className={styles.skeletonContainer}>
      <div className={roomResponsiveStyles.container}>
        <div className={roomResponsiveStyles.roomContainer}>
          <div className={roomResponsiveStyles.detailsContainer}>
            <div className={roomImageStyles.roomImageContainer}>
              <div className={roomImageStyles.roomImage}>
                <div className={styles.imageSkeleton} />
              </div>
            </div>
            <div className={roomResponsiveStyles.roomHeader}>
              <div className={styles.longTitleSkeleton} />
              <div className={styles.longTextSkeleton} />
              <div className={styles.skeletonInlineContainer}>
                <div className={styles.iconSkeleton} />
                <div className={styles.iconSkeleton} />
                <div className={styles.shortTextSkeleton} />
                &nbsp;
                <div className={styles.iconSkeleton} />
                <div className={styles.shortTextSkeleton} />
                &nbsp;
                <div className={styles.iconSkeleton} />
                <div className={styles.shortTextSkeleton} />
                &nbsp;
                <div className={styles.iconSkeleton} />
                <div className={styles.shortTextSkeleton} />
                &nbsp;
              </div>
              <div className={styles.shortTitleSkeleton} />
            </div>
          </div>
          <div
            className={cn(
              roomResponsiveStyles.offersContainer,
              roomResponsiveStyles.offersContainer
            )}
          >
            <div
              className={cn(
                offerResponsiveStyles.boardContainer,
                offerResponsiveStyles.boardContainer
              )}
            >
              <div className={styles.skeletonInlineContainer}>
                <div className={styles.iconSkeleton} />
                <div className={styles.shortTitleSkeleton} />
                <div className={styles.shortTitleSkeleton} />
                &nbsp;
                <div className={styles.longTextSkeleton} />
                &nbsp;
                <div className={styles.shortTextSkeleton} />
                &nbsp;
                <div className={styles.longTextSkeleton} />
                &nbsp;
              </div>
            </div>

            <div className={offerResponsivePriceAndButtonStyles.priceAndButtonBookingContainer}>
              <div className={offerResponsivePriceAndButtonStyles.priceBookingContainer}>
                <div className={styles.skeletonInlineContainer}>
                  <div className={styles.shortTextSkeleton} />
                  <div className={styles.shortTextSkeleton} />
                  <div className={styles.longTitleSkeleton} />
                  <div className={styles.longTextSkeleton} />
                  <div className={styles.shortTextSkeleton} />
                </div>
              </div>
              <div className={offerResponsivePriceAndButtonStyles.bookingButtonContainer}>
                <div className={styles.buttonSkeleton} />
              </div>
            </div>
          </div>
        </div>
        <PlaceholderShadow />
      </div>
    </div>
  )
}

export default RoomCardPlaceholder
